import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Eye, FileStack, PencilLine } from "lucide-react";
import { useAdmin } from "@/context/AdminContext";
import { PagesPanel } from "./PagesPanel";

/** Shown only while editing the website (entered from the dashboard's “Edit Website”). */
export const AdminBar = () => {
  const { siteMode, setSiteMode, editing, setEditing } = useAdmin();
  const [pagesOpen, setPagesOpen] = useState(false);
  const navigate = useNavigate();
  if (!siteMode) return null;
  const btn = "flex items-center gap-2 whitespace-nowrap rounded-full px-3 py-2.5 text-sm font-bold transition-colors sm:px-4";
  return (
    <>
      <div data-testid="admin-bar" className="fixed bottom-4 left-1/2 z-[45] flex -translate-x-1/2 items-center gap-1 rounded-full bg-[#0A0A0A] p-1.5 text-white shadow-2xl">
        <button onClick={() => { setSiteMode(false); navigate("/dashboard"); }} data-testid="admin-back-dashboard" className={`${btn} hover:bg-white/10`}>
          <ArrowLeft className="h-4 w-4" /><span>Dashboard</span>
        </button>
        <button onClick={() => setEditing(!editing)} data-testid="admin-toggle-edit" className={`${btn} ${editing ? "bg-[#E62314]" : "hover:bg-white/10"}`}>
          {editing ? <PencilLine className="h-4 w-4" /> : <Eye className="h-4 w-4" />}<span>{editing ? "Editing" : "Viewing"}</span>
        </button>
        <button onClick={() => setPagesOpen(true)} data-testid="admin-open-pages" className={`${btn} hover:bg-white/10`}>
          <FileStack className="h-4 w-4" /><span className="hidden sm:inline">Pages</span>
        </button>
      </div>
      <PagesPanel open={pagesOpen} onOpenChange={setPagesOpen} />
    </>
  );
};
